var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcInspections(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 7C17.984 7 20 9.016 20 11.5C20 13.984 17.984 16 15.5 16C13.016 16 11 13.984 11 11.5C11 9.016 13.016 7 15.5 7ZM9.521 12C9.564 12.522 9.674 13.025 9.842 13.5H0.75C0.336 13.5 0 13.164 0 12.75C0 12.336 0.336 12 0.75 12H9.521ZM13.225 11.976L14.667 13.261C14.762 13.346 14.882 13.388 15 13.388C15.136 13.388 15.271 13.333 15.37 13.226L17.811 10.557C17.899 10.461 17.942 10.34 17.942 10.221C17.942 9.947 17.721 9.722 17.442 9.722C17.306 9.722 17.171 9.777 17.072 9.884L14.964 12.188L13.891 11.232C13.795 11.147 13.677 11.105 13.558 11.105C13.281 11.105 13.058 11.329 13.058 11.604C13.058 11.741 13.114 11.877 13.225 11.976ZM10.627 8C10.299 8.456 10.033 8.96 9.842 9.5H0.75C0.336 9.5 0 9.164 0 8.75C0 8.336 0.336 8 0.75 8H10.627ZM18 4.75C18 4.336 17.664 4 17.25 4H0.75C0.336 4 0 4.336 0 4.75C0 5.164 0.336 5.5 0.75 5.5H17.25C17.664 5.5 18 5.164 18 4.75ZM18 0.75C18 0.336 17.664 0 17.25 0H0.75C0.336 0 0 0.336 0 0.75C0 1.164 0.336 1.5 0.75 1.5H17.25C17.664 1.5 18 1.164 18 0.75Z",
    fill: "#646C77"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInspections);
export default __webpack_public_path__ + "static/media/ic_inspections.1cba5efbd0357671c83afe2ad3a7dd2f.svg";
export { ForwardRef as ReactComponent };